export enum BacklightLevelEnum {
	ONE_LEVEL = 'OneLevel',
	TWO_LEVELS = 'TwoLevels',
	TWO_LEVELS_AUTO = 'TwoLevelsAuto',
	NO_CAPABILITY = 'NoCapability'
}

export enum BacklightStatusEnum {
	OFF = 'Off',
	LEVEL_1 = 'Level_1',
	LEVEL_2 = 'Level_2',
	AUTO = 'Auto',
	DISABLED_OFF = 'DisabledOff'
}
